import * as React from "react";
import {
  // alpha,
  Box,
  Button,
  Chip,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid"; // ✅ MUI v7 (size prop)
import CircleIcon from "@mui/icons-material/Circle";

import Section from "../components/ui/Section";
import { PROGRAM } from "../content/software";
import DemoDialog from "../components/ui/DemoDialog";

// بطاقة صغيرة بأيقونة في أعلى اليمين (حسب التصميم)
// function SmallCard({ title, desc, Icon }) {
//   return (
//     <Paper
//       elevation={0}
//       variant="outlined"
//       sx={{
//         p: { xs: 2, md: 2.5 },
//         borderRadius: 0.5,
//         position: "relative",
//         display: "grid",
//         gap: 1,
//         boxShadow: "0 10px 28px rgba(8, 28, 78, .06)",
//       }}
//     >
//       <Box
//         sx={(theme) => ({
//           width: 40,
//           height: 40,
//           borderRadius: 0.5,
//           display: "grid",
//           placeItems: "center",
//           flexShrink: 0,
//           bgcolor: alpha(theme.palette.primary.main, 0.05), // خلفية خفيفة
//           color: "primary.main",
//           border: "1px solid",
//           borderColor: "divider",
//         })}
//       >
//         <Icon fontSize="small" />
//       </Box>

//       <Typography sx={{ fontWeight: 900, color: "primary.dark" }}>
//         {title}
//       </Typography>
//       <Typography color="text.secondary" sx={{ lineHeight: 1.9 }}>
//         {desc}
//       </Typography>
//     </Paper>
//   );
// }

export default function Software() {
  const [openDemo, setOpenDemo] = React.useState(false);

  return (
    <Box sx={{ bgcolor: "grey.50" }}>
      <DemoDialog open={openDemo} onClose={() => setOpenDemo(false)} />

      <Section id="software" bgcolor="transparent">
        <Grid container spacing={4} alignItems="center">
          {/* النصوص (يمين في RTL) */}
          <Grid size={{ xs: 12, md: 6 }}>
            <Stack spacing={2.25}>
              <Typography
                variant="h2"
                sx={{
                  fontWeight: 900,
                  fontSize: { xs: 24, md: 32 },
                  color: "primary.dark",
                }}
              >
                {PROGRAM.title}
              </Typography>

              <Typography
                variant="h4"
                sx={{
                  fontWeight: 900,
                  color: "text.secondary",
                  fontSize: { xs: 18, md: 20 },
                }}
              >
                {PROGRAM.badge}
              </Typography>

              <Typography color="text.secondary" sx={{ lineHeight: 1.9 }}>
                {PROGRAM.subtitle}
              </Typography>

              {/* نقاط المزايا */}
              <List dense disablePadding sx={{ mt: 0.5 }}>
                {PROGRAM.bullets.map((b) => (
                  <ListItem key={b} sx={{ px: 0 }}>
                    <ListItemIcon sx={{ minWidth: 28, color: "success.main" }}>
                      <CircleIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText
                      primary={b}
                      primaryTypographyProps={{
                        variant: "body2",
                        sx: { lineHeight: 1.9 },
                      }}
                    />
                  </ListItem>
                ))}
              </List>

              {/* الأزرار */}
              <Stack direction="row" spacing={1.25} flexWrap="wrap" useFlexGap>
                <Button
                  variant="contained"
                  color="warning"
                  onClick={() => setOpenDemo(true)}
                  sx={{ fontWeight: 800, px: 6 }}
                >
                  {PROGRAM.ctas.consultLabel}
                </Button>
              </Stack>

              {/* القطاعات */}
              <Typography variant="body2" color="text.secondary">
                خدمنا قطاعات متعددة
              </Typography>
              <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
                {PROGRAM.industries.map((t) => (
                  <Chip
                    key={t}
                    label={t}
                    variant="outlined"
                    sx={{ borderRadius: 999 }}
                  />
                ))}
              </Stack>
            </Stack>
          </Grid>

          {/* المعاينة (يسار في RTL) */}
          <Grid size={{ xs: 12, md: 6 }}>
            <Paper
              elevation={0}
              variant="outlined"
              sx={{
                p: { xs: 2, md: 0 },
                borderRadius: 2,
                width: "100%",
                // ارتفاع مرن مع نسبة أبعاد جيدة
                aspectRatio: { xs: "16 / 9", md: "4 / 3" },
                display: "grid",
                placeItems: "center",
                textAlign: "center",
                background:
                  "linear-gradient(180deg, rgba(33,150,243,.06), rgba(33,150,243,.02))",
                boxShadow: "0 10px 28px rgba(8, 28, 78, .06)",
                overflow: "hidden",
              }}
            >
              <Box
                component="img"
                src="/assets/images/2.png"
                alt="معاينة البرنامج"
                loading="lazy"
                sx={{
                  width: "100%",
                  height: "100%",
                  borderRadius: "inherit",
                  objectFit: "fill", // لا يقص الصورة
                  backgroundColor: "#000",
                }}
              />
            </Paper>
          </Grid>
        </Grid>
      </Section>
    </Box>
  );
}
